// One-line "who is this" summary taken from a character description, for the
// "Suspects - Who's Who" cheat-sheet on the host Characters tab and on every guest sheet
// (ADR-0037 R3).
//
// The first sentence ends at . ! or ? followed by whitespace, except after a title or
// initial: "Mrs. Claus is the warm..." used to be cut to "Mrs." (customer report
// 2026-10-23, Gingerbread Festival).
const ABBREVIATIONS = new Set([
  'mr', 'mrs', 'ms', 'mx', 'dr', 'prof', 'st', 'mt', 'jr', 'sr', 'capt', 'cpt', 'lt', 'sgt',
  'col', 'gen', 'maj', 'cmdr', 'adm', 'rev', 'hon', 'fr', 'vs', 'etc', 'inc', 'ltd', 'no',
  // other languages the packages are written in
  'sra', 'srta', 'dra', 'sig', 'sigra', 'dott', 'dott.ssa', 'hr', 'mme', 'mlle', 'mevr', 'dhr',
]);

export function castBriefLine(desc?: string | null): string {
  const cleaned = (desc || '')
    .replace(/^#+\s*CHARACTER DESCRIPTION\s*/i, '')
    .replace(/[#*_>`]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  let sentence = cleaned;
  const ends = /[.!?](?=\s|$)/g;
  let m: RegExpExecArray | null;
  while ((m = ends.exec(cleaned)) !== null) {
    const end = m.index;
    if (cleaned[end] === '.') {
      const word = (cleaned.slice(0, end).match(/([\p{L}.]+)$/u)?.[1] || '').toLowerCase();
      // a title ("Mrs.") or a single initial ("J. Alfred Prufrock")
      if (ABBREVIATIONS.has(word) || /^\p{L}$/u.test(word)) continue;
    }
    sentence = cleaned.slice(0, end + 1);
    break;
  }

  return sentence.length > 160 ? `${sentence.slice(0, 157).trimEnd()}…` : sentence;
}
